angular.module('tgaAdmin')
  .controller('HubJourneysController', [
    '$scope', '$rootScope', '$state', '$window', '$filter', '$timeout', 'hubService', 'gameService',
    'modalService', 'flashService', '$log',
    function (
      $scope, $rootScope, $state, $window, $filter, $timeout, hubService, gameService,
      modalService, flashService, $log,
    ) {
      $scope.showBack = $state.current.data.back;

      $scope.data = {
        hub_id: $state.params.hub_id || null,
        alerts: [],
        backgrounds: [
          { background_id: 'mountains', name: 'Mountains' },
        ],
        itemTypes: [
          { id: 'game', name: 'Game' },
          { id: 'pdf', name: 'PDF' },
          { id: 'image', name: 'Image' },
          { id: 'video', name: 'Video' },
          { id: 'audio', name: 'Audio' },
          { id: 'link', name: 'URL' },
        ],
        dataTypes: [
          { id: 'iframe', name: 'Arcade (iframe)' },
          { id: 'external', name: 'New browser tab' },
        ],
        games: [],
      };

      $scope.activitySortableOptions = {
        items: '.stage-activity-container',
        containment: '.box',
        revert: 250,
        forcePlaceholderSize: true,
        tolerance: 'pointer',
        cursor: 'move',
        handle: '.handle',
        helper: 'original',
        scroll: true,
        placeholder: 'stage-activity-container',
        start(e, ui) {
          ui.placeholder.height(ui.item.height());
          ui.placeholder.width(ui.item.width());
        },
      };

      $scope.viewmodel = {
        mode: '', // 'list' or 'edit'
        journey_id: null,
        journeys: [],
        journey: null,
        newJourney: {
          course_group_id: null,
          course_group_type: 1, // COURSE_GROUP_TYPE_JOUNREY
          name: null,
          background: 'mountains',
          courses: [],
        },
        newCourse: {
          course_id: null,
          name: null,
          items: [],
          deleted: false,
        },
        newItem: {
          course_item_id: null,
          name: null,
          item_type: null,
          game_id: null,
          data: null,
          data_type: null,
          tile_image: null,
          deleted: false,
        },
      };

      $scope.initialize = function () {
        const route = $state.current.name.split('.')[2];

        if (route === 'addJourney') {
          $scope.viewmodel.mode = 'add';
        } else if (route === 'editJourney') {
          $scope.viewmodel.mode = 'edit';
          $scope.viewmodel.journey_id = $state.params.course_group_id;
        } else {
          $scope.viewmodel.mode = 'list';
        }

        $scope.loading = true;

        gameService.getAllGames({ exclude_extra_data: true }).then((games) => {
          $scope.data.games = games;
        });

        hubService.getHub($scope.data.hub_id).then((hub) => {
          $scope.viewmodel.hub = hub;
          $scope.title = `<span class="text-muted">Arcades / ${hub.name} /</span> Journeys`;

          if ($scope.viewmodel.mode === 'list') {
            hubService.getJourneys({ hub_id: hub.hub_id }).then((journeys) => {
              $scope.viewmodel.journeys = journeys;
              $scope.loading = false;
            });
          } else if ($scope.viewmodel.mode === 'edit') {
            hubService.getJourneys({ hub_id: hub.hub_id, course_group_id: $scope.viewmodel.journey_id }).then((journey) => {
              $scope.viewmodel.journey = { ...$scope.viewmodel.newJourney, ...journey };
              $scope.title = `<span class="text-muted">Arcades / ${hub.name} / Journeys / </span> ${journey.name}`;
              hubService.getJourneys({ hub_id: hub.hub_id }).then((journeys) => {
                $scope.viewmodel.journeys = journeys.filter((j) => j.course_group_id !== $scope.viewmodel.journey.course_group_id);
              });
              $scope.loading = false;
            });
          } else if ($scope.viewmodel.mode === 'add') {
            $scope.viewmodel.journey = { ...$scope.viewmodel.newJourney };
            hubService.getJourneys({ hub_id: hub.hub_id }).then((journeys) => {
              $scope.viewmodel.journeys = journeys.filter((j) => j.course_group_id !== $scope.viewmodel.journey.course_group_id);
            });
            $scope.title = `<span class="text-muted">Arcades / ${hub.name} / Journeys / </span> New Journey`;
            $scope.loading = false;
          }
        });
      };

      $scope.actions = {
        changeTile(item) {
          const reader = new FileReader();

          reader.onload = function (event) {
            item.tile_image = event.target.result;
            $scope.$apply();
          };

          // when the file is read it triggers the onload event above.
          reader.readAsDataURL(item.tile_image_file.file);
        },
        getDefaultTile(item) {
          switch (item.item_type) {
            case 'pdf':
              return 'https://static.thetrainingarcade.com/arcade/activities/pdf.png';
            case 'image':
              return 'https://static.thetrainingarcade.com/arcade/activities/image.png';
            case 'audio':
              return 'https://static.thetrainingarcade.com/arcade/activities/audio.png';
            case 'video':
              return 'https://static.thetrainingarcade.com/arcade/activities/video.png';
            case 'link':
              return 'https://static.thetrainingarcade.com/arcade/activities/website.png';
            case 'game':
              // eslint-disable-next-line no-case-declarations
              const game = $scope.data.games.find((g) => g.game_id === item.game_id);

              if (game) {
                return `https://static.thetrainingarcade.com/arcade/activities/${game.game_type}.png`;
              }
              return 'https://static.thetrainingarcade.com/arcade/avatars/Alphabet/alphabet__.png';

            default:
              return 'https://static.thetrainingarcade.com/arcade/avatars/Alphabet/alphabet__.png';
          }
        },
        addStage() {
          const newCourse = { ...$scope.viewmodel.newCourse };
          newCourse.items = []; // new object
          $scope.viewmodel.journey.courses.push(newCourse);
        },
        removeStage(stage) {
          stage.deleted = true;
        },
        addActivity(stage) {
          const newItem = { ...$scope.viewmodel.newItem };
          stage.items.push(newItem);
        },
        removeActivity(stage, activity) {
          activity.deleted = true;
        },
        changeItemType(item) {
          item.game_id = item.data = item.file = item.data_type = null;
          if (item.item_type === 'link' && item.data_type !== 'external') {
            item.data_type = 'iframe';
          }
        },
        notInStage(courseItems, position) {
          const items = courseItems.filter((item) => !item.deleted);

          return function (game) {
            const added = items.filter((item) => item.game_id === game.game_id && game.game_id !== items[position].game_id);

            return added.length === 0;
          };
        },
        videoEmbed(item) {
          if (item.data.includes('vimeo')) {
            // eslint-disable-next-line max-len
            const result = item.data.match(/(?:www\.|player\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/(?:[^/]*)\/videos\/|album\/(?:\d+)\/video\/|video\/|)(\d+)(?:[a-zA-Z0-9_-]+)?/i);
            item.data = `https://player.vimeo.com/video/${result[1]}`;
          } else if (item.data.includes('youtu')) {
            if (!item.data.includes('embed')) {
              const expr = /(youtu\.be\/|[?&]v=)([^&]+)/;
              item.data = `https://www.youtube.com/embed/${item.data.match(expr)[2]}`;
            }
          }
        },
        checkFile(item) {
          if (item.file.file.size > 31457280) {
            item.file = null;
            $scope.actions.createAlert(
              '<span class="fa fa-exclamation-triangle"></span> Files cannot be more than 30 MB in size.',
              'danger',
            );
          }
        },
        deleteJourney(journey) {
          modalService.showModal({
            title: 'Delete Journey?',
            message: 'Are you sure you want to delete this journey?',
            closeButton: 'No',
            actionButton: 'Yes',
          }, {
            backdrop: true,
            keyboard: true,
            animation: false,
          }).then(() => {
            $scope.deleting = true;

            hubService.deleteJourney(journey.course_group_id).then(
              () => {
                flashService.set('<span class="fa fa-check"></span> Journey deleted.', 'success');
                $state.go('v1.hub.journeys', {}, { reload: true });
              },
              (error) => {
                $scope.actions.createAlert(
                  `<span class="fa fa-exclamation-triangle"></span> <strong>Error!</strong> ${error.message}`,
                  'danger',
                );
                $scope.deleting = false;
              },
            );
          }, () => { });
        },
        // Reorder a stage (course) either down(1) or up(-1).
        reorderStage(stage, direction) {
          direction = direction === 'up' ? -1 : 1;
          const current = $scope.viewmodel.journey.courses.indexOf(stage);
          if (current === -1) {
            return;
          }
          const len = $scope.viewmodel.journey.courses.length;
          const newIndex = current + direction;
          if (newIndex > len - 1 || newIndex < 0) {
            return;
          }
          $scope.viewmodel.journey.courses = $scope.actions.changeValuePosition($scope.viewmodel.journey.courses, current, newIndex);
        },
        // Swap arr's elements at indexes init and target, return new arr.
        changeValuePosition(arr, init, target) {
          [arr[init], arr[target]] = [arr[target], arr[init]];
          return arr;
        },
        saveJourney(form) {
          $scope.submitted = true;

          if (form.$invalid) {
            return;
          }

          // Check minimum requirements for stages
          const stages = $scope.viewmodel.journey.courses.filter((course) => !course.deleted);

          if (stages.length < 2) {
            $scope.actions.createAlert(
              '<span class="fa fa-exclamation-triangle"></span> <strong>Error!</strong> Journey must contain 2 or more stages.',
              'danger',
            );
            return;
          }

          // Check minimum requirements for items
          for (let i = 0; i < stages.length; i++) {
            const items = stages[i].items.filter((item) => !item.deleted);

            if (!items.length) {
              $scope.actions.createAlert(
                '<span class="fa fa-exclamation-triangle"></span> <strong>Error!</strong> All stages must contain 1 or more activities.',
                'danger',
              );
              return;
            }
          }

          $scope.processing = true;

          if ($scope.viewmodel.mode === 'add') {
            hubService.addJourney({ journey: $scope.viewmodel.journey }).then(
              () => {
                flashService.set('<span class="fa fa-check"></span> Journey added.', 'success');
                $state.go('v1.hub.journeys');
              },
            ).catch((error) => {
              $log.error('error', error);
            });
          } else if ($scope.viewmodel.mode === 'edit') {
            hubService.editJourney($scope.viewmodel.journey_id, { journey: $scope.viewmodel.journey }).then(
              () => {
                flashService.set('<span class="fa fa-check"></span> Journey updated.', 'success');
                $state.go('v1.hub.editJourney', {
                  course_group_id: $scope.viewmodel.journey_id,
                }, {
                  reload: true,
                });
              },
            ).catch((error) => {
              $log.error('error', error);
            });
          }
        },
        createAlert(msg, type) {
          $scope.data.alerts = [];
          $scope.data.alerts.push({
            msg,
            type,
          });
        },
      };

      $scope.initialize();
    },
  ]);
